export default __webpack_public_path__ + "static/media/captionIcon.b949248d.svg";